module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-156.888465cf.svg";